'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var graphqlTag = require('graphql-tag');

var orderTrackingQuery = graphqlTag.gql`
  query OrderTracking(
    $retailerMoniker: String!
    $trackingNumbers: [String!]
    $orderNumbers: [String!]
    $type: String
    $orderType: OrderType
    $carrier: String
    $orderApiEnabled: Boolean
    $localeCountry: Country
    $localeLanguage: Language
    $destinationZip: String
    $email: String
    $phone: String
    $secured: Boolean
    $originZip: String
    $originCountry: String
    $destinationCountry: String
    $service: String
    $orderDate: String
    $shipDate: String
    $retailerDcId: String
    $productCategory: String
    $promiseDate: String
    $url: String!
    $cache: Boolean
    $mainShipmentId: String
    $shipmentHistoryDateFormatTranslationKeys: [MomentCalendarTranslationKeysInput!]!
    $experienceHost: ExperienceHost
    $versionName: String
    $token: String
  ) {
    orderTracking(
      retailerMoniker: $retailerMoniker
      trackingNumbers: $trackingNumbers
      orderNumbers: $orderNumbers
      type: $type
      orderType: $orderType
      carrier: $carrier
      orderApiEnabled: $orderApiEnabled
      localeCountry: $localeCountry
      localeLanguage: $localeLanguage
      destinationZip: $destinationZip
      email: $email
      phone: $phone
      secured: $secured
      originZip: $originZip
      originCountry: $originCountry
      destinationCountry: $destinationCountry
      service: $service
      orderDate: $orderDate
      shipDate: $shipDate
      retailerDcId: $retailerDcId
      productCategory: $productCategory
      promiseDate: $promiseDate
      mainShipmentId: $mainShipmentId
      cache: $cache
      eddFormatTranslationKeys: []
      shipmentHistoryDateFormatTranslationKeys: $shipmentHistoryDateFormatTranslationKeys
      versionName: $versionName
      token: $token
    ) {
      orderApiEnabled
      orders {
        mainShipmentId
        redirectUrl
        unauthenticatedRequest
        tokenPayload
        customerMarketingAttributes {
          billingZipSha256
          emailSha256
          firstNameSha256
          lastNameSha256
        }
        shipments {
          isFallback
          carrier
          carrierLogoUrl
          verificationContent {
            url
          }
          destination {
            lat
            lng
          }
          displayDate
          displayDateRange {
            begin
            end
          }
          history {
            description
            formattedDescription {
              format
              value
            }
            date
            dateFormatted
            city
            state
          }
          items {
            itemId
            productSku
            quantity
            name
            description
            imageUrl
            url
            fulfillmentStatus
            color
            size
            style
            customAttributes
            price
            currency
          }
          lastUpdate
          link(url: $url, experienceHost: $experienceHost)
          origin {
            lat
            lng
          }
          pickupLocation {
            directionUrl
            phoneNumber
            address {
              street1
              street2
              city
              state
              zip
            }
            geocode {
              lat
              lng
            }
            name
            hours {
              day
              hoursRange
            }
            openStatus
            openStatusTime
          }
          scheduling {
            isSchedulable
            isScheduled
          }
          shipmentId
          status
          statusCode
          trackingNumber
          trackingUrl
          type
          vehicle {
            driver {
              name
              photo
              contact {
                id
                email
                phone
                address
                proxyPhoneNumber
              }
            }
            type
            color
            make
            model
            year
            licensePlate
          }
        }
      }
    }
  }
`;

exports["default"] = orderTrackingQuery;
